'use client'

import React from 'react'

import {CatalogProductListContent} from '@/src/core/domain/entities/catalog'
import {BrandsCatalogContent} from '@/src/core/domain/entities/catalog/types'

import {CatalogOptions} from '@/src/features/catalog'

import {CatalogPaginationContainer} from '@/src/(pages)/catalog/pagination-container'
import * as UI from '@/src/(pages)/catalog/screen.styled'
import {ProductsListContainer} from '@/src/features/catalog/product-list/products-list-container'
import {FiltersCsrContainer} from '@/src/features/catalog/filters-v2'
import {PageData} from '@/src/core/domain/entities/page/page-data'

export const BrandProductListScreen: React.FC<PageData<BrandsCatalogContent>> = props => {
  const {content} = props

  return <BrandProductListContainer products={content.products.items} sort={content.sort} />
}

const BrandProductListContainer = ({
  products,
  sort,
}: {
  products: CatalogProductListContent['products']['items']
  sort: CatalogProductListContent['sort']
}) => {
  return (
    <UI.Wrapper data-testid="catalog">
      <UI.ContainerCentered>
        <UI.Container>
          <UI.Side>
            <FiltersCsrContainer />
          </UI.Side>

          <UI.Content>
            {products.length > 0 && (
              <UI.CatalogOptions as={CatalogOptions} sort={sort}>
                <CatalogPaginationContainer />
              </UI.CatalogOptions>
            )}

            <ProductsListContainer products={products} />
            {products.length > 0 && (
              <UI.MobilePagination as={CatalogPaginationContainer} withoutOptions />
            )}
          </UI.Content>
        </UI.Container>
      </UI.ContainerCentered>
    </UI.Wrapper>
  )
}
